import { Mensaje } from "@/components/mensajes2";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

export default function ModalImprimirListadoLicencias(props) {
  const op = require("@/modulos/datos");
  const anioActual = new Date().getFullYear();
  const [select, setSelect] = useState("todos");
  const [fechas, setFechas] = useState({
    desde: `${anioActual}-01-01`,
    hasta: new Date().toISOString().split("T")[0],
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const imprimirReporte = () => {
    try {
      const condicion =
        select === "fecha"
          ? ` lxl.fechaemision between '${fechas.desde}' and '${fechas.hasta}'`
          : " 1=1";
      const titulo =
        select === "fecha"
          ? ` DESDE EL ${fechas.desde} HASTA EL ${fechas.hasta}`
          : "";
      window.open(
        `${op.reportes}/actividadeconomica?reporte=ListaLicenciaLicores&CONDICION=${condicion}&TIT_RGO1=${titulo}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  const salir = () => {
    props.setTabla();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Impresión de Listado General de Solicitudes de Licencias
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-center">
          <div className="col-md-8 d-flex justify-content-between gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fecha"
                value="todos"
                id="todos"
                checked={select === "todos"}
                onChange={() => {
                  setSelect("todos");
                }}
              />
              <label className="form-check-label" htmlFor="todos">
                Todos
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fecha"
                value="fecha"
                id="fecha"
                checked={select === "fecha"}
                onChange={() => {
                  setSelect("fecha");
                }}
              />
              <label className="form-check-label" htmlFor="fecha">
                Por Fecha
              </label>
            </div>
          </div>
          {select === "fecha" && (
            <div className="col-md-12 d-flex justify-content-center gap-3 pt-4">
              <div className="input-group input-group-sm mb-2 col-md-4">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Desde:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.desde}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      desde: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="input-group input-group-sm mb-2 col-md-4">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Hasta:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.hasta}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      hasta: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
    </Modal>
  );
}
